import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { getValidationRules } from '../validation/validation';
import SIGN_UP_RULES from '../validation/validationRules/signUp';
import UpdateInfoComponent from '../components/profile/Profile/UpdateInfoComponent';
import { validationRules } from './CompanyFormContainer';
import { setLoading, updatePersonalInfo } from '../store/actions/session';
import { getLoadingStatus } from './selectors/licenseSelectors';
import { isUserAdmin, getCurrentUser } from './selectors/userSelectors';

const _ = require('lodash');

const UPDATE_PERSONAL_INFO_FORM = 'update-personal-info';

const mapStateToProps = (state) => ({
    isLoading: getLoadingStatus(state),
    canEdit: isUserAdmin(state),
    currentUserInfo: getCurrentUser(state),
});

const mapDispatchToProps = {
    setLoading,
    updatePersonalInfo,
}

const mergeProps = (
    { history, company, ...stateProps, currentUserInfo },
    { updatePersonalInfo, setLoading },
) => {
    return {
        setLoading,
        ...stateProps,
        initialValues: currentUserInfo,
        onSubmit: (data) => {
            let prevData = {...currentUserInfo};
            if (!_.isEqual(data, prevData)) {
                prevData = data;

                let promise;
                if (data) {
                    promise = updatePersonalInfo(data.uid, data);
                }

                return promise.then().finally(() => {
                    prevData = {};
                });
            }
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: UPDATE_PERSONAL_INFO_FORM,
    validate: getValidationRules([
        'firstName',
        'lastName',
    ].concat(validationRules), Object.assign(SIGN_UP_RULES)),
})(UpdateInfoComponent));
//export default withRouter(connect(currentMapStateToProps, mapDispatchToProps, mergeProps)(UpdateProfilePanelComponent));



// WEBPACK FOOTER //
// ./src/containers/UpdateInfoContainer.js